import type { WixConfig } from '@wix/cli-app-definitions';
import {
  WIX_CONFIG_FILENAME,
  getWixConfigFilePath,
} from '@wix/cli-core-definitions';
import { wixConfigSchema } from '@wix/cli-app-definitions';
import { readJson, writeJson } from '@wix/cli-fs';
import { CliError, CliErrorCode } from '@wix/cli-error';

export async function readWixConfig(projectFolder: string) {
  const configFile = await readJson(getWixConfigFilePath(projectFolder));
  const config = wixConfigSchema.safeParse(configFile);

  if (config.success) {
    return config.data;
  }

  throw new CliError({
    code: CliErrorCode.InvalidConfigSchemaError({
      configPath: WIX_CONFIG_FILENAME,
      zodError: config.error,
    }),
    cause: config.error,
  });
}

export async function saveWixConfig(projectFolder: string, config: WixConfig) {
  await writeJson(getWixConfigFilePath(projectFolder), config, { spaces: 2 });
}
